import React from 'react';
import { KibButtonNew } from '@chewy/kib-controls-react';
import { cancelText, removeClinicSupportiveText, removeClinicText } from './vetContent';
import { Clinic } from './vetClinicResponse';
import VetClinicCard from './VetClinicCard';

const RemoveVetClinic = ({
  clinic,
  onCancelClick,
  onRemoveClick,
}: {
  clinic: Clinic;
  onCancelClick?: (...args: []) => void;
  onRemoveClick?: (...args: []) => void;
}) => (
  <div className="pet-form-vet-remove__sheet" data-testid="pet-form-vet-remove-sheet">
    <div className="pet-form-vet-remove__border">
      <VetClinicCard clinic={clinic} />
    </div>
    <div className="pet-form-vet-remove__summary">{removeClinicSupportiveText}</div>
    <span>
      <KibButtonNew
        type="button"
        className="pet-form-vet-remove__removeBtn"
        emphasis="secondary"
        theme="destructive"
        size="large"
        data-testid="pet-form-vet-remove__removeBtn"
        onClick={onRemoveClick}
      >
        {removeClinicText}
      </KibButtonNew>
      <KibButtonNew
        type="button"
        className="pet-form-vet-remove__cancelBtn"
        emphasis="tertiary"
        data-testid="pet-form-vet-remove__cancelBtn"
        size="large"
        onClick={onCancelClick}
      >
        {cancelText}
      </KibButtonNew>
    </span>
  </div>
);

export default RemoveVetClinic;
